import * as React from 'react';
import { useSelector } from 'react-redux';

import { PrintContainer } from './print';
import { RemoveContainer } from './remove/RemoveContainer';
import { selectSelectedEntitiesCount } from '../../selectors';
import { selectSelectedFolder } from '../../selectors/folders';

export const MassActionsContainer = () => {
  const isSelected = Boolean(useSelector(selectSelectedEntitiesCount));
  const selectedFolder = Boolean(useSelector(selectSelectedFolder));

  return (
    <>
      {isSelected && <PrintContainer />}
      {(!selectedFolder || isSelected) && <RemoveContainer />}
    </>
  );
};
